import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

const RECORDS_PER_PAGE = 30;

export const pendingUserRoleRequests: racehorse360.IListUserRoleRequestsRequest =
  {
    query: {
      userRoleRequestStatuses: [
        racehorse360.UserRoleRequestStatus.USER_ROLE_REQUEST_STATUS_REQUESTED
      ]
    },
    pagingOptions: {
      maxResults: RECORDS_PER_PAGE
    },
    getOptions: {
      select: [
        "facility.name",
        "role.name",
        "role.roleType",
        "trainerName",
        "userRoleRequestStatus",
        "user.firstName",
        "user.lastName",
        "user.email",
        "user.licenseNumber",
        "user.phoneNumber"
      ],
      orderBy: ["role.name"]
    }
  };
